import React from "react";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { embedDashboard } from "@superset-ui/embedded-sdk";
import {
  supersetLogin,
  supersetGuestToken,
  fetchLeafMenuInfo,
} from "../apis/user-apis";
import {
  superset_password,
  superset_username,
  superset_first_name,
  superset_last_name,
  superset_domain,
} from "../../env";
function SupersetDashboard() {
  const { subMenu, dashboardName } = useParams();

  const [supersetDashboardID, setSupersetDashboardId] = useState(null);



  async function fetchGuestTokenFromBackend() {
    const payload = {
      password: superset_password,
      provider: "db",
      refresh: "false",
      username: superset_username,
    };

    try {
      const resp = await supersetLogin(payload);

      const guestTokenPayload = {
        user: {
          username: superset_username,
          first_name: superset_first_name,
          last_name: superset_last_name,
        },
        rls: [],
        resources: [
          {
            type: "dashboard",
            id: supersetDashboardID,
          },
        ],
      };

      const GuestTokenResp = await supersetGuestToken(
        guestTokenPayload,
        resp.data.access_token
      );


      return GuestTokenResp.data.token;
    } catch (err) {
      console.log("err", err);
      return null; // Ensure to handle this null appropriately where this function is called.
    }
  }

  function embedDashboardWithToken() {
    fetchGuestTokenFromBackend().then((token) => {
      console.log("token", token);
      if (!token) {
        return; // Token fetch failed, handle appropriately.
      }

      embedDashboard({
        id: supersetDashboardID, // given by the Superset embedding UI
        supersetDomain: superset_domain,
        mountPoint: document.getElementById("my-superset-container"), // any html element that can contain an iframe
        fetchGuestToken: () => Promise.resolve(token), // Since the token is already fetched, we just return it wrapped in a resolved Promise.
        dashboardUiConfig: {
          hideTitle: true,
          hideChartControls: true,
          // hideTab: true,
          filters: {
            expanded: false,
            // visible: false,
          },
          // urlParams: {
          //     foo: 'value1',
          //     bar: 'value2',
          //     // ...
          // }
        },
      });
    });
  }

  useEffect(() => {
    const params = {};
    const path = `/users/workspace/${subMenu}/${dashboardName}/`;
    params["menu_leaf_path"] = path;
    fetchLeafMenuInfo(params)
      .then((resp) => {
        const respData = resp.data;
        setSupersetDashboardId(
          respData?.superset_dashbord ? respData.superset_dashbord : null
        );
      })
      .catch((err) => {
        console.log("err", err);
      });
  }, []);

  useEffect(() => {
    if (supersetDashboardID) {
      embedDashboardWithToken();
    }
  }, [supersetDashboardID]);
  return <div id="my-superset-container"></div>;
}

export default SupersetDashboard;
